import { WithStyles, withStyles } from '@material-ui/core/styles'
import createStyles from '@material-ui/core/styles/createStyles'
import React from 'react'
import { useTranslation } from 'react-i18next'

import AnimatedLoader from 'src/components/AnimatedLoader'

const styles = () =>
  createStyles({
    root: {
      position: 'absolute',
      display: 'flex',
      width: '100%',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(0, 0, 0, 0.1)',
    },
    progressContainer: {
      display: 'flex',
      width: '100%',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
    },
  })

interface IMapProgressBar extends WithStyles {
  progress: number
}

const MapProgressBar = (props: IMapProgressBar) => {
  const { classes, progress } = props
  const { t } = useTranslation()
  if (progress == 1) {
    return null
  }

  return (
    <div className={classes.root}>
      <div className={classes.progressContainer}>
        <AnimatedLoader loadingMessage={t('map.loadingMessage') + ' ' + (progress * 100).toFixed() + '%'} />
      </div>
    </div>
  )
}

export default withStyles(styles)(MapProgressBar)
